var map = {
	"./404.svg": "b1b5",
	"./Mega Discount.svg": "3322",
	"./apps-01.svg": "c9de",
	"./arrow_down.svg": "ccd8",
	"./arrow_green.svg": "21b5",
	"./bottom-arrow.svg": "0e8f",
	"./caret-right-01.svg": "9c6e",
	"./check-mark-success-v2.gif": "484f",
	"./check-mark-success.gif": "be7e",
	"./check.svg": "e7d6",
	"./chevron-left.svg": "dc03",
	"./circle-01.svg": "62fa3",
	"./clock-01.svg": "343d",
	"./close.svg": "0572",
	"./cod.svg": "0b2e",
	"./credit-card.svg": "3840",
	"./cut-the-price.svg": "0a3d",
	"./cuttheprice.jpg": "7a22",
	"./cuttheprice.png": "9cec",
	"./eye-01.svg": "8480",
	"./hand.png": "d122",
	"./heart.png": "8a04",
	"./home.svg": "7936",
	"./in-love.png": "1ef2",
	"./info.svg": "3e95",
	"./live_tv.svg": "c189",
	"./long-arrow-01.svg": "65ad",
	"./mic.svg": "81b0",
	"./no-internet.svg": "f3d1",
	"./norecord.svg": "efb7",
	"./oye-lucky.svg": "bfae",
	"./payment-failed.svg": "e677",
	"./payment_success.svg": "f7a5",
	"./paytm.jpg": "7c56",
	"./person.svg": "ceb9",
	"./red-heart.png": "1371",
	"./right-arrow.png": "2ab9",
	"./search.png": "13b1",
	"./search.svg": "f919",
	"./shape.svg": "b69e",
	"./shopping-cart.svg": "3ab1",
	"./shopping-games.svg": "75c0",
	"./shopping_basket.svg": "5dc4",
	"./star.png": "de1f",
	"./star2.png": "dd96",
	"./star91.jpg": "9508",
	"./star_ptrn.svg": "266c",
	"./thumb.svg": "945a",
	"./tv.svg": "667c",
	"./video-play-icon/youtube-play.png": "227b",
	"./video-play-icon/youtube-play@2x.png": "9b70",
	"./video-play-icon/youtube-play@3x.png": "aac4",
	"./wallet.svg": "1113",
	"./watermark.svg": "dfd6",
	"./youtube-play.png": "c5b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";